import CardBController from "./CardBController";

export default CardBController;
